export interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  category: string;
  location: string;
  date: string;
}

export const galleryCategories = [
  { name: 'All', count: 29 },
  { name: 'Community Events', count: 5 },
  { name: 'Education', count: 6 },
  { name: 'Healthcare', count: 5 },
  { name: 'Food Relief', count: 4 },
  { name: 'Women Empowerment', count: 3 },
  { name: 'Environment', count: 3 },
  { name: 'Disaster Relief', count: 2 },
  { name: 'Animal Welfare', count: 1 },
];

export const galleryImages: GalleryImage[] = [
  {
    id: 101,
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/03d2b155-bb18-4322-b5ea-e28ef04c548f_compressed_WhatsApp-Image-2026-07-28-at-1.03.10-PM.webp',
    alt: 'Large group of girls with Happy Faces volunteers — thumbs up',
    category: 'Community Events',
    location: 'Vidyanagar, Hyderabad',
    date: 'July 2026',
  },
  {
    id: 102,
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/3cce0a52-a2a7-4e74-930b-aa1a01e46561_compressed_WhatsApp-Image-2026-07-28-at-1.03.12-PM.webp',
    alt: 'Happy Faces Hyderabad girls community gathering session',
    category: 'Community Events',
    location: 'Vidyanagar, Hyderabad',
    date: 'July 2026',
  },
  {
    id: 103,
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/ffdcfd54-4b00-4116-a2e7-12ec73716629_compressed_WhatsApp-Image-2026-07-28-at-1.03.13-PM.webp',
    alt: 'Happy Faces Hyderabad Rural Development Welfare Society — official banner event',
    category: 'Community Events',
    location: 'Vidyanagar, Hyderabad',
    date: 'July 2026',
  },
  {
    id: 104,
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/1c7a5be3-d015-4be9-bb55-83c43dd932f3_compressed_WhatsApp-Image-2026-07-28-at-1.03.16-PM.webp',
    alt: 'Children gathering at Happy Faces community event, Hyderabad',
    category: 'Community Events',
    location: 'Vidyanagar, Hyderabad',
    date: 'July 2026',
  },
  {
    id: 105,
    src: 'https://storage.readdy-site.link/project_files/a20ac005-7779-424b-9c89-d21aef816197/fcc529ed-7139-48bb-9cb9-20d7d39555df_compressed_WhatsApp-Image-2026-07-28-at-1.03.18-PM.webp',
    alt: 'Boys school visit — Happy Faces youth outreach program',
    category: 'Community Events',
    location: 'Hyderabad, Telangana',
    date: 'July 2026',
  },
  {
    id: 1,
    src: 'https://readdy.ai/api/search-image?query=Rajasthani%20village%20government%20school%20children%20in%20white%20and%20blue%20uniforms%20sitting%20on%20mats%20in%20bright%20classroom%20receiving%20colorful%20notebooks%20and%20pencils%20from%20smiling%20female%20volunteer%20in%20cotton%20saree%2C%20Hindi%20alphabet%20charts%20on%20wall%2C%20natural%20daylight%20from%20large%20windows%2C%20joyful%20expressions%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-01&orientation=portrait',
    alt: 'School supplies distribution in Rajasthan',
    category: 'Education',
    location: 'Jaipur, Rajasthan',
    date: 'March 2026',
  },
  {
    id: 2,
    src: 'https://readdy.ai/api/search-image?query=Free%20medical%20camp%20under%20large%20banyan%20tree%20in%20rural%20Maharashtra%2C%20elderly%20villagers%20in%20white%20dhotis%20and%20cotton%20kurtas%20waiting%20in%20line%2C%20young%20doctor%20in%20white%20coat%20with%20stethoscope%20examining%20wrinkled%20elderly%20woman%2C%20medical%20instruments%20on%20folding%20table%2C%20warm%20afternoon%20sunlight%20filtering%20through%20leaves%2C%20documentary%20photography&width=800&height=600&seq=gallery-health-01&orientation=landscape',
    alt: 'Rural medical camp in Maharashtra',
    category: 'Healthcare',
    location: 'Nashik, Maharashtra',
    date: 'February 2026',
  },
  {
    id: 3,
    src: 'https://readdy.ai/api/search-image?query=Community%20kitchen%20langar%20hall%20in%20Amritsar%20Punjab%2C%20volunteers%20in%20headscarves%20and%20aprons%20ladling%20dal%20and%20chapati%20into%20steel%20plates%20for%20rows%20of%20seated%20people%2C%20large%20brass%20vessels%20with%20steam%20rising%2C%20warm%20golden%20interior%20light%2C%20grateful%20elderly%20man%20accepting%20food%20with%20folded%20hands%2C%20documentary%20photography&width=600&height=600&seq=gallery-food-01&orientation=squarish',
    alt: 'Langar meal distribution in Punjab',
    category: 'Food Relief',
    location: 'Amritsar, Punjab',
    date: 'January 2026',
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=Indian%20women%20in%20bright%20bandhani%20and%20leheriya%20sarees%20sitting%20in%20circle%20doing%20hand%20embroidery%20and%20mirror%20work%20at%20skill%20training%20center%20in%20Bhuj%20Gujarat%2C%20colorful%20threads%20and%20fabric%20pieces%20on%20wooden%20table%2C%20one%20woman%20showing%20completed%20piece%20to%20instructor%2C%20natural%20light%20from%20window%2C%20concentrated%20happy%20expressions%2C%20documentary%20photography&width=600&height=800&seq=gallery-women-01&orientation=portrait',
    alt: 'Women embroidery workshop in Gujarat',
    category: 'Women Empowerment',
    location: 'Bhuj, Gujarat',
    date: 'December 2025',
  },
  {
    id: 5,
    src: 'https://readdy.ai/api/search-image?query=Indian%20tribal%20community%20members%20in%20traditional%20cotton%20clothing%20planting%20neem%20and%20peepal%20saplings%20on%20dry%20hillside%20in%20Madhya%20Pradesh%2C%20earthen%20pots%20for%20watering%2C%20children%20helping%20dig%20holes%2C%20bright%20blue%20sky%20with%20white%20clouds%2C%20collective%20community%20effort%20for%20reforestation%2C%20documentary%20photography&width=800&height=600&seq=gallery-env-01&orientation=landscape',
    alt: 'Tree plantation drive in Madhya Pradesh',
    category: 'Environment',
    location: 'Jabalpur, Madhya Pradesh',
    date: 'June 2026',
  },
  {
    id: 6,
    src: 'https://readdy.ai/api/search-image?query=Assam%20flood%20relief%20operation%2C%20volunteers%20in%20life%20vests%20distributing%20packaged%20food%20and%20clean%20water%20bottles%20from%20inflatable%20boat%20to%20families%20standing%20on%20submerged%20road%2C%20partially%20underwater%20traditional%20Assamese%20house%20with%20bamboo%20frame%20in%20background%2C%20overcast%20sky%2C%20urgent%20but%20organized%20rescue%2C%20documentary%20photography&width=600&height=600&seq=gallery-disaster-01&orientation=squarish',
    alt: 'Flood relief in Assam',
    category: 'Disaster Relief',
    location: 'Guwahati, Assam',
    date: 'July 2026',
  },
  {
    id: 7,
    src: 'https://readdy.ai/api/search-image?query=Young%20Indian%20schoolgirls%20in%20blue%20and%20white%20salwar%20kameez%20uniforms%20reading%20books%20together%20at%20new%20library%20in%20rural%20government%20school%20in%20Tamil%20Nadu%2C%20wooden%20shelves%20with%20colorful%20Hindi%20and%20Tamil%20books%2C%20teacher%20in%20cotton%20saree%20guiding%20them%2C%20bright%20classroom%20with%20green%20chalkboard%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-02&orientation=portrait',
    alt: 'Girls education program in Tamil Nadu',
    category: 'Education',
    location: 'Madurai, Tamil Nadu',
    date: 'April 2026',
  },
  {
    id: 8,
    src: 'https://readdy.ai/api/search-image?query=Mobile%20dental%20clinic%20van%20parked%20at%20village%20square%20in%20Uttar%20Pradesh%2C%20young%20dentist%20in%20white%20coat%20examining%20teeth%20of%20smiling%20village%20boy%20with%20mouth%20mirror%2C%20mother%20in%20cotton%20saree%20watching%20with%20relief%2C%20other%20children%20waiting%20on%20bench%2C%20rural%20setting%20with%20mango%20trees%2C%20documentary%20photography&width=800&height=600&seq=gallery-health-02&orientation=landscape',
    alt: 'Mobile dental camp in Uttar Pradesh',
    category: 'Healthcare',
    location: 'Lucknow, Uttar Pradesh',
    date: 'May 2026',
  },
  {
    id: 9,
    src: 'https://readdy.ai/api/search-image?query=Volunteers%20distributing%20hot%20midday%20meal%20plates%20with%20rice%20dal%20and%20vegetables%20to%20schoolchildren%20in%20large%20open%20courtyard%20of%20government%20school%20in%20Odisha%2C%20children%20sitting%20in%20rows%20on%20floor%20mats%20with%20steel%20plates%2C%20teacher%20in%20saree%20supervising%2C%20red%20brick%20school%20building%20background%2C%20bright%20sunny%20day%2C%20documentary%20photography&width=600&height=600&seq=gallery-food-02&orientation=squarish',
    alt: 'Midday meal program in Odisha',
    category: 'Food Relief',
    location: 'Bhubaneswar, Odisha',
    date: 'March 2026',
  },
  {
    id: 10,
    src: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20Indian%20women%20in%20business%20casual%20kurtis%20and%20palazzo%20pants%20attending%20computer%20literacy%20class%20at%20NGO%20training%20center%20in%20Delhi%2C%20desktop%20monitors%20showing%20Microsoft%20Excel%20and%20Hindi%20typing%20software%2C%20instructor%20pointing%20at%20screen%2C%20whiteboard%20with%20notes%2C%20fluorescent%20tube%20lights%2C%20determined%20focused%20faces%2C%20documentary%20photography&width=600&height=800&seq=gallery-women-02&orientation=portrait',
    alt: 'Computer training for women in Delhi',
    category: 'Women Empowerment',
    location: 'New Delhi',
    date: 'February 2026',
  },
  {
    id: 11,
    src: 'https://readdy.ai/api/search-image?query=Community%20members%20in%20Kerala%20building%20low-cost%20rainwater%20harvesting%20tank%20in%20village%20school%20courtyard%2C%20men%20in%20lungis%20and%20women%20in%20mundu%20mixing%20concrete%2C%20bamboo%20scaffolding%2C%20lush%20green%20coconut%20palms%20in%20background%2C%20overcast%20monsoon%20sky%2C%20sustainable%20water%20conservation%20project%2C%20documentary%20photography&width=800&height=600&seq=gallery-env-02&orientation=landscape',
    alt: 'Rainwater harvesting project in Kerala',
    category: 'Environment',
    location: 'Kochi, Kerala',
    date: 'August 2025',
  },
  {
    id: 12,
    src: 'https://readdy.ai/api/search-image?query=Indian%20veterinarian%20in%20white%20coat%20gently%20vaccinating%20brown%20Indie%20street%20puppy%20at%20makeshift%20animal%20shelter%20under%20tin%20roof%2C%20NGO%20volunteer%20in%20olive%20kurta%20holding%20puppy%20calm%2C%20other%20rescued%20dogs%20in%20clean%20steel%20cages%20nearby%2C%20rural%20clinic%20setting%20with%20medical%20supplies%2C%20compassionate%20atmosphere%2C%20documentary%20photography&width=600&height=600&seq=gallery-animal-01&orientation=squarish',
    alt: 'Animal vaccination drive in Karnataka',
    category: 'Animal Welfare',
    location: 'Bangalore, Karnataka',
    date: 'April 2026',
  },
  {
    id: 13,
    src: 'https://readdy.ai/api/search-image?query=Indian%20tribal%20children%20in%20colorful%20traditional%20clothes%20sitting%20in%20new%20brick%20classroom%20in%20Jharkhand%2C%20young%20male%20teacher%20in%20checked%20shirt%20writing%20on%20green%20chalkboard%20in%20Hindi%2C%20colorful%20educational%20posters%20on%20mud%20walls%2C%20single%20bulb%20hanging%20from%20ceiling%2C%20eager%20attentive%20expressions%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-03&orientation=portrait',
    alt: 'Tribal school program in Jharkhand',
    category: 'Education',
    location: 'Ranchi, Jharkhand',
    date: 'January 2026',
  },
  {
    id: 14,
    src: 'https://readdy.ai/api/search-image?query=Eye%20screening%20camp%20in%20Bihar%20village%2C%20elderly%20woman%20with%20white%20hair%20and%20bindu%20sitting%20while%20ophthalmologist%20uses%20ophthalmoscope%2C%20her%20grandson%20in%20white%20kurta%20standing%20beside%20her%2C%20other%20villagers%20in%20colorful%20cotton%20clothes%20waiting%20outside%20tent%2C%20mango%20tree%20providing%20shade%2C%20warm%20afternoon%20light%2C%20documentary%20photography&width=800&height=600&seq=gallery-health-03&orientation=landscape',
    alt: 'Eye camp in Bihar',
    category: 'Healthcare',
    location: 'Patna, Bihar',
    date: 'March 2026',
  },
  {
    id: 15,
    src: 'https://readdy.ai/api/search-image?query=Young%20Indian%20boys%20in%20blue%20school%20uniforms%20excitedly%20using%20new%20desktop%20computers%20in%20bright%20computer%20lab%20of%20rural%20government%20school%20in%20Haryana%2C%20teacher%20in%20saree%20guiding%20one%20student%20pointing%20at%20screen%2C%20Windows%20desktop%20visible%2C%20clean%20tiled%20floor%2C%20fluorescent%20lights%2C%20digital%20literacy%20program%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-04&orientation=portrait',
    alt: 'Digital education in Haryana',
    category: 'Education',
    location: 'Chandigarh, Haryana',
    date: 'May 2026',
  },
  {
    id: 16,
    src: 'https://readdy.ai/api/search-image?query=Indian%20volunteers%20distributing%20packed%20grocery%20kits%20with%20rice%20lentils%20oil%20and%20spices%20to%20elderly%20widows%20and%20disabled%20people%20at%20community%20center%20in%20West%20Bengal%2C%20women%20in%20white%20and%20pastel%20cotton%20sarees%20accepting%20bags%20with%20folded%20hands%2C%20stacks%20of%20ration%20packets%20on%20table%2C%20warm%20community%20atmosphere%2C%20documentary%20photography&width=600&height=600&seq=gallery-food-03&orientation=squarish',
    alt: 'Grocery distribution in West Bengal',
    category: 'Food Relief',
    location: 'Kolkata, West Bengal',
    date: 'April 2026',
  },
  {
    id: 17,
    src: 'https://readdy.ai/api/search-image?query=NGO%20volunteers%20in%20orange%20vests%20setting%20up%20temporary%20relief%20tents%20and%20distributing%20blankets%20to%20families%20affected%20by%20cyclone%20on%20beach%20in%20Odisha%2C%20palm%20trees%20bent%20from%20wind%2C%20children%20wrapped%20in%20shawls%20holding%20food%20packets%2C%20overcast%20stormy%20sky%2C%20organized%20disaster%20response%2C%20documentary%20photography&width=800&height=600&seq=gallery-disaster-02&orientation=landscape',
    alt: 'Cyclone relief in Odisha',
    category: 'Disaster Relief',
    location: 'Puri, Odisha',
    date: 'June 2026',
  },
  {
    id: 18,
    src: 'https://readdy.ai/api/search-image?query=Self-help%20group%20of%20Indian%20women%20in%20Rajasthan%20sitting%20under%20thatched%20roof%20counting%20currency%20notes%20from%20microfinance%20loan%20repayment%2C%20account%20books%20and%20calculators%20on%20table%2C%20one%20woman%20in%20ghagra%20choli%20explaining%20to%20group%2C%20bright%20traditional%20clothing%2C%20rural%20village%20courtyard%20setting%2C%20empowerment%20and%20financial%20independence%2C%20documentary%20photography&width=600&height=800&seq=gallery-women-03&orientation=portrait',
    alt: 'Self-help group meeting in Rajasthan',
    category: 'Women Empowerment',
    location: 'Udaipur, Rajasthan',
    date: 'May 2026',
  },
  {
    id: 19,
    src: 'https://readdy.ai/api/search-image?query=Indian%20schoolchildren%20in%20green%20uniforms%20planting%20saplings%20in%20school%20garden%20in%20Himachal%20Pradesh%2C%20misty%20mountain%20backdrop%20with%20pine%20trees%2C%20teacher%20in%20pahari%20shawl%20supervising%2C%20small%20watering%20cans%20and%20gardening%20tools%2C%20fresh%20mountain%20air%20atmosphere%2C%20environmental%20education%20program%2C%20documentary%20photography&width=800&height=600&seq=gallery-env-03&orientation=landscape',
    alt: 'School garden program in Himachal Pradesh',
    category: 'Environment',
    location: 'Shimla, Himachal Pradesh',
    date: 'April 2026',
  },
  {
    id: 20,
    src: 'https://readdy.ai/api/search-image?query=Mobile%20health%20van%20parked%20at%20remote%20village%20in%20Andhra%20Pradesh%2C%20nurse%20in%20white%20uniform%20taking%20blood%20pressure%20of%20elderly%20farmer%20in%20white%20dhoti%2C%20medical%20equipment%20on%20foldable%20table%2C%20thatched%20huts%20in%20background%2C%20green%20paddy%20fields%2C%20warm%20late%20afternoon%20sunlight%2C%20primary%20healthcare%20reaching%20rural%20areas%2C%20documentary%20photography&width=600&height=600&seq=gallery-health-04&orientation=squarish',
    alt: 'Mobile health van in Andhra Pradesh',
    category: 'Healthcare',
    location: 'Vijayawada, Andhra Pradesh',
    date: 'February 2026',
  },
  {
    id: 21,
    src: 'https://readdy.ai/api/search-image?query=Indian%20adolescent%20girls%20in%20blue%20uniforms%20attending%20science%20workshop%20in%20rural%20school%20in%20Maharashtra%2C%20young%20woman%20instructor%20in%20white%20lab%20coat%20demonstrating%20chemistry%20experiment%20with%20beakers%20and%20colored%20liquids%2C%20students%20watching%20with%20fascination%2C%20science%20charts%20on%20wall%2C%20natural%20light%2C%20STEM%20education%20for%20girls%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-05&orientation=portrait',
    alt: 'STEM workshop for girls in Maharashtra',
    category: 'Education',
    location: 'Pune, Maharashtra',
    date: 'June 2026',
  },
  {
    id: 22,
    src: 'https://readdy.ai/api/search-image?query=Volunteers%20in%20aprons%20and%20caps%20serving%20hot%20khichdi%20and%20chapati%20from%20large%20steel%20vessels%20to%20homeless%20people%20at%20night%20shelter%20in%20Delhi%2C%20people%20sitting%20on%20floor%20with%20steel%20plates%2C%20winter%20fog%20visible%2C%20warm%20lights%20from%20shelter%2C%20compassionate%20service%2C%20community%20feeding%20program%2C%20documentary%20photography&width=600&height=600&seq=gallery-food-04&orientation=squarish',
    alt: 'Night shelter meals in Delhi',
    category: 'Food Relief',
    location: 'New Delhi',
    date: 'January 2026',
  },
  {
    id: 23,
    src: 'https://readdy.ai/api/search-image?query=Antenatal%20care%20camp%20for%20pregnant%20women%20in%20rural%20Karnataka%2C%20female%20doctor%20in%20white%20coat%20with%20stethoscope%20examining%20expectant%20mother%20in%20colorful%20cotton%20saree%2C%20ultrasound%20machine%20in%20corner%2C%20other%20pregnant%20women%20sitting%20on%20benches%2C%20clean%20bright%20clinic%20room%20with%20health%20posters%20in%20Kannada%2C%20maternal%20healthcare%2C%20documentary%20photography&width=800&height=600&seq=gallery-health-05&orientation=landscape',
    alt: 'Maternal health camp in Karnataka',
    category: 'Healthcare',
    location: 'Mysore, Karnataka',
    date: 'May 2026',
  },
  {
    id: 24,
    src: 'https://readdy.ai/api/search-image?query=Indian%20boy%20in%20school%20uniform%20showing%20his%20new%20bicycle%20received%20through%20scholarship%20program%20in%20rural%20Telangana%2C%20proud%20smile%20with%20missing%20front%20teeth%2C%20parents%20in%20traditional%20cotton%20clothes%20standing%20behind%20him%20admiringly%2C%20village%20mud%20house%20and%20cow%20in%20background%2C%20bright%20sunny%20day%2C%20education%20access%20initiative%2C%20documentary%20photography&width=600&height=800&seq=gallery-edu-06&orientation=portrait',
    alt: 'Scholarship bicycle distribution in Telangana',
    category: 'Education',
    location: 'Hyderabad, Telangana',
    date: 'March 2026',
  },
];